// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AwsRhelInstancesIcon = createSvgIcon(
  <svg width={40} height={40} fill="none" viewBox="0 0 40 40">
    <path fill="url(#aws-rhel-instances_svga)" d="M40 0H0v40h40z" />
    <svg width={28} height={22} x={6} y={9} viewBox="0 0 28 22">
      <path
        fill="url(#aws-rhel-instances_svgb)"
        d="m23.46 10.54.24 1.54c.38 6.84-18.54 2.23-18.24-3.54 0-.39.08-.7.24-1.08l.53-1.3s13.08 3.38 16.93 3z"
      />
      <path
        fill="#fff"
        d="M18.7 12.23c1.84 0 4.45-.38 4.45-2.54q.04-.27 0-.54L22 4.38c-.23-1-.46-1.53-2.3-2.46C18.3 1.23 15.14 0 14.3 0c-.92 0-1.15 1.15-2.15 1.15S10.46.31 9.54.31 8.08.92 7.62 2.15l-1.39 4q-.06.15-.08.31c0 1.3 5.39 5.77 12.54 5.77m4.76-1.7.23 1.55c0 2-2.3 3.15-5.3 3.15-6.93 0-12.93-4-12.93-6.7q0-.55.23-1.07C3.23 7.62 0 8.08 0 10.85c0 4.61 11 10.38 19.7 10.38 6.6 0 8.3-3 8.3-5.38 0-1.93-1.62-4-4.54-5.31"
      />
    </svg>
    <defs>
      <linearGradient
        id="aws-rhel-instances_svga"
        x1={0}
        x2={40.99}
        y1={0}
        y2={38.96}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
      <linearGradient
        id="aws-rhel-instances_svgb"
        x1={23.7}
        x2={5.16}
        y1={12.08}
        y2={6.15}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF6B35" />
        <stop offset={1} stopColor="#D2001B" />
      </linearGradient>
    </defs>
  </svg>,
  "AwsRhelInstances",
);
export default AwsRhelInstancesIcon;
